import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../../../services';
import { PartnerService } from '../../../../../../services/partner.service';
import { AutoComplete } from 'primeng/autocomplete';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-copy-shops',
  templateUrl: './copy-shops.component.html',
  styleUrls: ['./copy-shops.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService]  
})
export class CopyShopsComponent implements OnInit {
  @ViewChild('sourceAutoComplete') sourceAutoComplete: AutoComplete;
  @ViewChild('destinationAutoComplete') destinationAutoComplete: AutoComplete;

  copyOptions: any = [];
  busy: boolean = false;

  public sourceShopSuggestions: any = [];
  public sourceShopSelected: any = null;

  public destinationShopSuggestions: any = [];
  public destinationShopSelected: any = null;

  public availableCopyOptions: any[] = [];
  public selectedCopyOptions: any[] = [];
  public displayedCopyOptions: any[] = [];

  constructor(
    private partnerService: PartnerService,
    public messageService: MessageService
  ) { }

  ngOnInit() {
    this.setCopyOptions();
  }

  searchShop(event, type) {
    var query = event.query;

    if (query.length >= 3) {
      this.partnerService.getPartnersCopyShop(1, 10, query).subscribe((partners) => {
        if (type == 'source') {
          this.sourceShopSuggestions = partners;
        }
        else {
          this.destinationShopSuggestions = partners;
        }
      });
    }
    else {
      if (type == 'source') {
        this.sourceShopSuggestions = [];
      }
      else {
        this.destinationShopSuggestions = [];
      }
    }
  }

  selectShop(event, type) {
    console.log('Selected Shop:', event);
    if (type == 'source') {
      this.sourceShopSelected = event.value;
      this.sourceAutoComplete.hide();
      console.log(this.sourceShopSelected);
    }
    else {
      this.destinationShopSelected  = event.value;
      this.destinationAutoComplete.hide();
      console.log(this.destinationShopSelected);
    }

    if(this.sourceShopSelected && this.destinationShopSelected)
    {
      if(this.sourceShopSelected.id == this.destinationShopSelected.id)
        {
          this.destinationShopSelected = null;
          this.messageService.add({ life: 5000, summary: "Desintation shop cannot be the source shop." });
        }
    }    
  }

  setCopyOptions() {
    this.partnerService.getCopyShopConfig().subscribe((items) => {
      console.log('config', items);

      this.availableCopyOptions = items.map(group => ({
        label: group.groupName,  
        items: group.items.map(item => ({
          name: item.displayName,  
          value: item.id,
          code: item.variableName  
        }))
      }));

      console.log(this.availableCopyOptions);
    });
  }

  onCopyOptionChange(event){
    // Update displayedCopyOptions based on selectedCopyOptions
    this.displayedCopyOptions = this.selectedCopyOptions.map(selected => {
      // Search for the selected option in the availableCopyOptions
      const group = this.availableCopyOptions.find(group => 
        group.items.some(item => item.value === selected.value)
      );

      if (group) {
        const item = group.items.find(item => item.value === selected.value);

        // Use the variable name `code` to look up the total in the shop object
        let getTotalForType = this.sourceShopSelected[item?.code] || null; 

        // Dynamically determine the total value from the shop object based on code
        return {
          name: item?.name || '',
          total: getTotalForType 
        };
      }
    });  
  }

  confirmCopy(){
    console.log('From:', this.sourceShopSelected);
    console.log('To:', this.destinationShopSelected);
    console.log('With params:', this.selectedCopyOptions);

    var obj = {
      SourcePartnerID: this.sourceShopSelected.id,
      DestinationPartnerID: this.destinationShopSelected.id,
      CopyOptions: this.selectedCopyOptions.map(x => x.code)
    };
    console.log(obj);

    this.busy = true;
    this.partnerService.copyStoreSettingsV2(obj).subscribe((res) => {
      this.sourceShopSelected = null;
      this.destinationShopSelected = null;
      this.selectedCopyOptions = [];
      this.displayedCopyOptions = [];

      this.messageService.add({ life: 5000, summary: "Shop details has been copied succesfully!" });
      this.busy = false;
    }, err => {
      //this.messageService.add({ life: 5000, summary: "Failed to copy shop details" });
      this.busy = false;
    });
  }

}
